export default "__VITE_PUBLIC_ASSET__65e59858__"